import { render, staticRenderFns } from "./custom-swipe.mpx?vue&type=template&id=181c146e&isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex"
import script from "./custom-swipe.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex"
export * from "./custom-swipe.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex"
import style0 from "./custom-swipe.mpx?vue&type=style&index=0&id=181c146e&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_9993b994%22%7D&isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports